// Lecture du presse-papiers initiée dans le contexte du geste utilisateur.
//
// navigator.clipboard.readText() exige une activation utilisateur transitoire
// ET le focus du document, vérifiés au moment de l'APPEL. Comme les actions
// clavier sont traitées dans une file asynchrone (enqueueAction), appeler
// readText() depuis cette file échoue avec « NotAllowedError: Document is not
// focused ». On démarre donc la lecture directement dans le handler keydown
// (contexte du geste) et on consomme la promesse plus tard.

let pendingRead = null;

// À appeler de façon SYNCHRONE dans le handler keydown (Ctrl+V).
export function startClipboardRead() {
  // On neutralise le rejet pour éviter toute « unhandled rejection » si la
  // promesse n'est jamais consommée (ex. collage interne d'une sélection).
  pendingRead = navigator.clipboard.readText().then(
    (text) => text,
    () => null
  );
}

// Récupère (et vide) la lecture démarrée par startClipboardRead().
// Retourne une promesse<string|null>, ou null si aucune lecture en attente.
export function takeClipboardRead() {
  const read = pendingRead;
  pendingRead = null;
  return read;
}

export function writeClipboard(text) {
  return navigator.clipboard.writeText(text).then(
    () => console.log('presse-papiers modifié avec succès'),
    () => console.log("échec de l'écriture dans le presse-papiers")
  );
}